import { createSlice } from '@reduxjs/toolkit';

export const successOrderCount = createSlice({
  name: 'successOrderCount',
  initialState: {
    data: 0,
  },

  reducers: {
    setSuccessOrderCount: (state, action) => {
      state.data = action.payload;
    },
  },
});

export const { setSuccessOrderCount } = successOrderCount.actions;

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state) => state.isLoading`
export const getSuccessOrderCount = (state) => {
  return state.successOrderCount.data;
};

export default successOrderCount.reducer;
